<template>
  <div class="table">

    <child-search-bar @query="handleQuery"></child-search-bar>

    <a-button style="margin-left:12px" type="primary" @click="addData">新增</a-button>

    <a-table rowKey="id" :loading="loading" :dataSource="userList" :pagination="false" :scroll="{x:true}">
      <a-table-column
        title="UID"
        dataIndex="id"
      />
      <a-table-column
        title="姓名"
        dataIndex="username"
      />
      <a-table-column
        title="手机号"
        dataIndex="phone"
      ><template slot-scope="phone">
        <span>{{ filterMobile(phone) }}</span>
      </template>
      </a-table-column>
      <a-table-column
        title="账号类型"
        dataIndex="subtype"
        width="120px"
      >
        <template slot-scope="subtype">
          <span>{{ filterSubType(subtype) }}</span>
        </template>
      </a-table-column>
      <a-table-column
        title="所属事业部"
        dataIndex="bussdep"
        width="120px"
      />
      <a-table-column
        title="权限"
        dataIndex="auditapps"
      >
        <template slot-scope="auditapps">
          <span>{{ filterApps(auditapps) }}</span>
        </template>
      </a-table-column>
      <a-table-column
        title="创建时间"
        width="300px"
        dataIndex="applytime"
      />
      <a-table-column
        title="状态"
        width="100px"
        dataIndex="status"
      ><template slot-scope="status">
        <span>{{ filterStatus(status) }}</span>
      </template>
      </a-table-column>
      <a-table-column
        title="操作"
        width="200px"
      ><template slot-scope="userid">
        <a v-show="userid.status == 'pass'" @click="modifyPass(userid.id)">修改密码&nbsp;</a>
        <a v-show="userid.status == 'pass'" @click="modify(userid.id)">编辑&nbsp;</a>
        <a-popconfirm title="确认注销该账号？" @confirm="deleteAccout(userid.id)">
          <a v-show="userid.status == 'pass'" >注销账号</a>
        </a-popconfirm>
      </template>
      </a-table-column>
    </a-table>
    <a-modal
      :title="this.chooseId?'修改子账号':'新增子账号'"
      width="600px"
      @ok="handleOk"
      @cancel="visible=false"
      :visible="visible">
      <a-form-item
        v-if="!this.chooseId"
        label="申请人姓名"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }">
        <a-input v-model="newData.name"/>
      </a-form-item>
      <a-form-item
        v-if="!this.chooseId"
        label="申请人手机号"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }">
        <a-input v-model="newData.phone"/>
      </a-form-item>
      <a-form-item
        label="账号类型"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }">
        <a-radio-group v-model="newData.subtype" @change="changeType">
          <a-radio value="2">子账号管理</a-radio>
          <a-radio value="3">子账户审核</a-radio>
        </a-radio-group>
      </a-form-item>

      <a-form-item label="业务&权限">
      </a-form-item>
      <a-checkbox-group v-model="newData.auditappid" style="width: 100%">
        <div v-for="(key,index) in childList" :key="index">
          <strong>{{ filterType(index) }}</strong><br>
          <a-checkbox v-for="item in key" :value="item.id" :key="item.id">{{ item.name }}&nbsp;&nbsp;</a-checkbox>
          <br>
          <br>
        </div>
      </a-checkbox-group>
    </a-modal>
    <a-modal
      title="修改密码"
      width="400px"
      @ok="handleOk1"
      @cancel="visible1=false"
      :visible="visible1">
      <a-form-item
        label="输入新密码"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 16 }">
        <a-input placeholder="输入新密码" v-model="newPass"/>
      </a-form-item>
      <br>
      <a-form-item
        label="再次输入密码"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 16 }">
        <a-input placeholder="再次输入密码" v-model="renewPass"/>
      </a-form-item>
    </a-modal>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { listsub, editAccount, addSubAccount, editauditscope } from '@/api/account'
  import { resetpasswd, depList, configmanageList } from '@/api/common'
  import { bussdepType,filterBussdepType } from '@/config/public'
import ChildSearchBar from './childSearchBar.vue'

  var newData = {
    name:'',
    phone:'',
    subtype:'',
    auditappid:[]
  }
  export default {
    name: 'ChildManage',
    components: {ChildSearchBar},
    data() {
      return {
        bussdepType:bussdepType,
        filterType:filterBussdepType,
        newData:newData,
        loading:false,
        rejectReason:'',
        visible:false,
        visible1:false,
        chooseId:0,
        newPass:'',
        renewPass:'',
        businssDept:[],
        childList:{},
        userList:[],
        noshowAuditappid:[],
      }
    },
    created() {

    },
    mounted() {
      if(window.environment == 'bz'){
        this.bussdepType =  bussdepType.filter(item=>item.value==='投教')
      }
      depList().then(res => {
        if(res.code==1){
          if(window.environment == 'bz'){
            this.businssDept = res.result.filter(item=>item.name=='博众事业部')
          }else{
            this.businssDept = res.result
          }
        }
      })
      this.getList()
      this.getAllChildList()
    },
    methods: {
      ...mapGetters(['userInfo']),
      filterSubType(type){
        var ss = String(type)
        switch(ss){
          case '0':return '系统账号'
          case '1':return '主账号'
          case '2':return '子账号管理'
          case '3':return '子账号审核'
        }
      },
      filterMobile(mobile){
        mobile = mobile+''
        return mobile.substring(0,3)+'****'+mobile.substring(7,mobile.length)
      },
      handleOk1(){
        if (!this.newPass){
          this.$message.error('密码不为空')
          return
        }
        if (this.newPass!=this.renewPass){
          this.$message.error('密码不一致')
          return
        }
        resetpasswd({password:this.newPass,uid:this.chooseId}).then(res=>{
          if (res.code==1){
            this.$message.success('修改成功')
            this.visible1 = false
          }
        })
      },
      modifyPass(id){
        this.chooseId = id
        this.renewPass = ''
        this.newPass = ''
        this.visible1 = true
      },
      modify(id){
        this.chooseId = id
        this.userList.forEach(item=>{
          if (item.id==id){
            if (item.auditapps){
              this.newData.subtype = String(item.subtype)
              this.newData.auditappid = []
              item.auditapps.forEach(itemm=>{
                this.newData.auditappid.push(itemm.id)
              })
            }
          }
        })
        
        var tmpChild = []
        for(var key in this.childList){
          if(this.childList[key] instanceof Array){
            this.childList[key].forEach(item=>{
              tmpChild.push(item.id)
            })
          }
        }
        
        var noremovelist = []
        for(let k=0;k<this.newData.auditappid.length;k++){
          var tmpK = this.newData.auditappid[k]
          if(tmpChild.indexOf(tmpK)<0){
            noremovelist.push(tmpK)
          }
        }
        this.noshowAuditappid = noremovelist


        this.visible = true
      },
      deleteAccout(id){
        editAccount({type:'del',uid:id}).then(res=>{
          if (res.code==1){
            this.$message.success('操作成功')
            this.getList()
          }
        })
      },
      getAllChildList(){
        configmanageList().then(res=>{
          if (res.code==1){
            // this.childList = res.result
            if(res.result&&res.result instanceof Array){
              res.result.forEach(item=>{
                if (!this.childList[item.bussdepType]){
                  this.$set(this.childList,item.bussdepType,[item])
                } else{
                  this.childList[item.bussdepType].push(item)
                }
              })
            }
          }
        })
      },
      addData(){
        this.chooseId = 0
        this.newData = JSON.parse(JSON.stringify(newData))
        this.newData.auditappid = []
        this.visible = true
      },
      filterBuss(id){
        var str = ''
        this.businssDept.forEach(item=>{
          if (item.id == id){
            str = item.name
          }
        })
        return str
      },
      filterApps(arr){
        var str = ''
        arr.forEach(item=>{
          var bussId = this.filterType(item.bussdepType)
          str += bussId + '(' + item.name +')'
        })
        return str
      },
      filterStatus(item){
        if (item=='pass'){
          return '可用'
        } else if (item=='del'){
          return '注销'
        }
      },
      getList(params = {}){
        this.loading = true
        listsub(params).then(res=>{
          if (res.code==1){
            this.userList = res.result
          }
        }).finally(()=>{
          this.loading = false
        })
      },
      handleOk(){
        if (this.chooseId==0){
          if (!this.newData.name){
            this.$message.error('名称不为空')
            return
          }
          if (!this.newData.phone){
            this.$message.error('phone不为空')
            return
          }
          if (!this.newData.subtype){
            this.$message.error('账号类型必选')
            return
          }
          var params = JSON.parse(JSON.stringify(this.newData))
          params.auditappid = params.auditappid.join(',')

          var params = JSON.parse(JSON.stringify(this.newData))
          var auditappid = params.auditappid
          if(this.noshowAuditappid&&this.noshowAuditappid.length>0){
            var addAppid = JSON.parse(JSON.stringify(this.noshowAuditappid))
            auditappid = auditappid.concat(addAppid)
          }
          params.auditappid = auditappid.join(',')

          addSubAccount(params).then(res=>{
            if (res.code==1){
              this.$message.success('新增成功')
              this.visible = false
              this.getList()
            }
          })
        }else{
          var auditappid = this.newData.auditappid
          if(this.noshowAuditappid&&this.noshowAuditappid.length>0){
            var addAppid = JSON.parse(JSON.stringify(this.noshowAuditappid))
            auditappid = auditappid.concat(addAppid)
          }
          
          editauditscope({uid:this.chooseId,subtype:this.newData.subtype,auditappid:auditappid.join(',')}).then(res=>{
            if (res.code==1){
              this.$message.success('修改成功')
              this.visible = false
              this.getList()
            }
          })
        }
      },
      handleQuery(params){
        this.getList(params)
      },
      changeType(){
        this.newData.auditappid = []
        if (this.newData.subtype=='2'){
          for(var key in this.childList){
            if(this.childList[key] instanceof Array){
              this.childList[key].forEach(item=>{
                this.newData.auditappid.push(item.id)
              })
            }
          }
        }
      }
    },
    // watch:{
    //   "newData.subtype":function (val) {
    //      else if (val=="3"){
    //
    //     }
    //   }
    // }
  }
</script>

<style lang="less" scoped>
  .select{
    width:200px;
  }
  .ant-form-item{
    margin-bottom: 0;
  }
</style>